import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import AddInvoicesByCorporate from "./addInvoicesByCorporateForLabs";
import { Pagination } from "react-bootstrap";
import { format, parse } from "date-fns";
import AddInvoiceTransaction from "./invoiceTransactionPopup";
import InvoiceTransactionsHistory from "./invoiceTransactionsHistory";
import { FiInfo } from "react-icons/fi";

function ViewOutgoingInvoicesByLabCorporate(labcode) {
    const [invoices, setInvoices] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loader, setLoader] = useState(true);
    const [labs, setLabs] = useState([]);
  const [invoiceNumberFilter, setInvoiceNumberFilter] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLab, setSelectedLab] = useState("all");
  const [isTransactionPopupOpen, setIsTransactionPopupOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

    
    const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;
      const orgcode = JSON.parse(localStorage.getItem("data")).orgcode;
  
  useEffect(() => {
                 if (searchTerm || selectedLab !=="all" || invoiceNumberFilter || selectedDate || statusFilter !== "all") {
                   setCurrentPage(0); // Reset page before fetching new search data
                 }
               }, [searchTerm, selectedLab, invoiceNumberFilter, selectedDate, statusFilter]);
               
               useEffect(() => {
                 if (searchTerm || selectedLab !=="all" || invoiceNumberFilter || selectedDate || statusFilter !== "all") {
                   searchData(currentPage); // Fetch new search data with updated page number
                 } else {
                   getData(currentPage);
                 }
               }, [searchTerm, selectedLab, invoiceNumberFilter, selectedDate, statusFilter, currentPage]);
               
        
        const searchData = async (page = 0) => {
          setLoader(true);
          try {
            const searchUrl = `/api/invoiceSearch/searchLabInvoicesBylabCorporate?page=${page}`;
            const requestData = {
              invoiceNumber: invoiceNumberFilter || null,
              date: selectedDate || null,
              labId: selectedLab === "all" ? null : selectedLab,
              status: statusFilter === "all" ? null : statusFilter,
              createdBy:"Lab",
              invoiceType:"outgoing",
              labCorporateOrgcode:orgcode
            };
      
            const response = await axios.post(searchUrl, requestData, {
              headers: { Authorization: `Bearer ${token}` },
            });
      
            setInvoices(response.data.content);
            setCurrentPage(response.data.number);
            setTotalPages(response.data.totalPages);
            setLoader(false);
          } catch (error) {
            setLoader(false);
            handleError(error);
          }
        };
     
    const getData = async (pageNumber = 0) => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      setLoader(true);
      try {
        const response = await axios.get(`/api/labdetails/linkedLabsByCorporateOrgcode/orgcode=${orgcode}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setLabs(response.data);
        const trans = await axios.get(`/api/invoices/getOutgoingInvoicesByLabcorporateOrgcode/${orgcode}`, {
          params: { page: pageNumber },
          headers: { Authorization: `Bearer ${token}` },
        });
  
        setInvoices(trans.data.content);
        setCurrentPage(trans.data.number);
        setTotalPages(trans.data.totalPages);
  
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    };
  
    const handleCreateInvoices = () => {
      setIsModalOpen(true);
    };
  
    const handleCloseModal = () => {
      setIsModalOpen(false);
      getData();
    };
  
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };

      
const [pdfUrl, setPdfUrl] = useState(null);
const handleViewPdf = async (appointmentId) => {
  const token = JSON.parse(localStorage.getItem("data")).token;
  await axios({
    url: `/api/invoices/download/id=${appointmentId}`,
    method: "GET",
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    console.log("filedata;", response);
    const contentType = response.headers["content-type"];
    let extension = "";

    // Determine the file extension based on content type
    if (contentType.includes("application/pdf")) {
      extension = "pdf";
    } else if (contentType.includes("image/jpeg")) {
      extension = "jpg";
    } else if (contentType.includes("image/png")) {
      extension = "png";
    } else {
      console.error("Unsupported file type:", contentType);
      return;
    }

    // Create a blob URL and download link for the file
    const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `file.${extension}`);
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  });
}

function handleError(error) {
  if (error.response) {
    if (error.response.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else if (error.response.data && error.response.data.message) {
      toast.error(error.response.data.message);
    }  else if (error.response.data && error.response.data.code) {
      toast.error(error.response.data.code);
    }
     else {
      toast.error("An error occurred.");
    }
  } else if (error.message) {
    toast.error(error.message);
  } else {
    toast.error("An error occurred.");
  }
}

const [isInvoiceTransactionModalOpen, setIsInvoiceTransactionModalOpen] = useState(false);
const handleOpenTransactionHistory = (invoiceId) => {
setSelectedInvoiceId(invoiceId);
setIsInvoiceTransactionModalOpen(true);
};
const handleCloseInvoiceTransactionModal = () => {
setIsInvoiceTransactionModalOpen(false);
setSelectedInvoiceId(null);
searchData(0);
};

const handleSearchInvoiceNumber = (event) => {
        setInvoiceNumberFilter(event.target.value.toLowerCase());
      };
    
      const handleDateChange = (date) => {
        if (date) {
          const formattedDate = format(date, "MM/yyyy");
          setSelectedDate(formattedDate); 
        } else {
          setSelectedDate(null);
        }
      };
    
      const handleStatusFilterChange = (e) => {
        setStatusFilter(e.target.value);
      };

      const handleLabFilterChange = (event) => {
        setSelectedLab(event.target.value); 
    };

      const handleOpenTransactionPopup = (invoiceId) => {
        setSelectedInvoiceId(invoiceId);
        setIsTransactionPopupOpen(true);
      };
    
      const handleCloseTransactionModal = () => {
        setIsTransactionPopupOpen(false);
        getData();
      };
    
   const renderPageNumbers = () => {
      const pageNumbers = [];
      const maxPageNumbersToShow = 5;
      let startPage = Math.max(0, currentPage - 2);
      let endPage = Math.min(totalPages - 1, currentPage + 2);
  
      if (currentPage <= 2) {
        endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
      }
  
      if (currentPage >= totalPages - 3) {
        startPage = Math.max(0, totalPages - maxPageNumbersToShow);
      }
  
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
            {i + 1}
          </Pagination.Item>
        );
      }
      return pageNumbers;
    };

    return (
      <div>
   
          <div className="col-12 mx-xl-auto">
          {/* <div className="form-group position-relative" style={{ width: '300px' }}> 
    <input
      type="search"
      className="form-control pl-4"
      placeholder="Search by company name or company code"
      value={searchTerm}
      onChange={handleSearch}
      style={{ paddingLeft: "2rem", width: "100%" }} 
    />
    <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
      <FontAwesomeIcon icon={faSearch} />
    </span>
  </div> */}
  
            
            <br />
            <div className="card card-raised ">
              <div className="card-body ">
                <div className="card-title form-group d-flex align-items-center justify-content-between">
                  <span>Outgoing Lab Invoices</span>
                  <div>
  
                    <button className="btn btn-primary" onClick={handleCreateInvoices}>
                      ADD
                    </button>
                  </div>
                </div>
                <br />
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label htmlFor="invoiceNumberFilter" className="form-label">
                    Search by Invoice Number:
                  </label>
                  <input
                    type="search"
                    className="form-control"
                    id="invoiceNumberFilter"
                    placeholder="Search by Invoice Number"
                    value={invoiceNumberFilter || null}
                    onChange={handleSearchInvoiceNumber}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="monthYearFilter" className="form-label">
                    Filter by Month and Year:
                  </label>
                  <DatePicker
  selected={selectedDate ? parse(selectedDate, "MM/yyyy", new Date()) : null}
  onChange={handleDateChange}
  showMonthYearPicker
  dateFormat="MM/yyyy"
  className="form-select"
  placeholderText="Select Month and Year"
/>
                </div>

                <div className="col-md-3 mb-3">
                  <label htmlFor="statusFilter" className="form-label">
                    Filter by Status:
                  </label>
                  <select
                    id="statusFilter"
                    className="form-select"
                    value={statusFilter || "all"}
                    onChange={handleStatusFilterChange}
                  >
                       <option value="all">ALL</option>
                    <option value="Invoice Generated">INVOICE GENERATED</option>
                    <option value="Partial Payment">PARTIAL PAYMENT</option>
                    <option value="Paid">PAID</option>
                  </select>
                </div>

                <div className="col-md-3 mb-3">
                  <label htmlFor="labFilter" className="form-label">
                    Filter by Lab:
                  </label>
                  <select
                    id="labFilter"
                    className="form-select"
                    value={selectedLab || "all"}
                    onChange={handleLabFilterChange}
                  >
                    <option value="all">All Labs</option>
                    {labs.map((lab) => (
                      <option key={lab.id} value={lab.id}>
                        {lab.labname}
                      </option>
                    ))}
                  </select>
                </div>
  
              </div>
  
                <br />
                <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                      <th>Lab</th>
                      <th>Date</th>
                      <th>Period</th>
                      <th>Invoice Number</th>
                      <th>Gross Amount</th>
                      <th>Tax</th>
                      <th>Net Pay</th>
                      <th>File</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No Data Available
                        </td>
                      </tr>
                    ) : (
                      invoices.map((invoice) => (
                        <tr key={invoice.id}>
                          <td>{invoice.lab?.labname}</td>
                          <td>{invoice.date} </td>
                          <td>{invoice.startdate} to {invoice.enddate}</td>
                          <td>{invoice.invoicenumber}</td>
                          <td>{invoice.grossamount}</td>
                          <td>{invoice.tax}</td>
                          <td>{invoice.netpay}</td>
                          <td>
                          {invoice.invoiceFileUploaded===true  ? (
                          <button
                            className="btn btn-primary"
                            onClick={() => handleViewPdf(invoice.id)}
                          >
                            View
                          </button>
                        ) : (
                          "No File Added"
                        )}
                        </td>
                        <td>
                          <div style={{ display: "flex", alignItems: "center" }}>
  {invoice.invoiceStatus?.status}
  {invoice.invoiceStatus?.status === "Paid" && (
    <FiInfo
      onClick={() => handleOpenTransactionHistory(invoice.id)}
      style={{
        cursor: "pointer",
        marginLeft: "8px", // Adjust spacing as needed
      }}
    />
  )}
  </div>
<br/>
{invoice.invoiceStatus?.status === "Partial Payment" && (
  <>
    <div style={{ color: "green", fontWeight: "bold" }}>
        Paid : ₹{invoice.paidAmount}
      </div>

      <div style={{ color: "red", fontWeight: "bold" }}>
        Pending: ₹{invoice.pendingAmount}
      </div>
      </>
)}
{invoice.invoiceStatus?.status !== "Paid" && (
  <>
    <button
      className="btn btn-success btn-sm rounded-pill"
      onClick={() => handleOpenTransactionPopup(invoice.id)}
    >
      Payment Received
    </button>
    </>
)}
</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
  
                <div>

                <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>
                  {isModalOpen && (
                    <AddInvoicesByCorporate isOpen={isModalOpen} onRequestClose={handleCloseModal}/>
                  )}
                {isTransactionPopupOpen && <AddInvoiceTransaction isOpen={isTransactionPopupOpen} onRequestClose={handleCloseTransactionModal} invoiceid={selectedInvoiceId} />}

                {isInvoiceTransactionModalOpen && (
                    <InvoiceTransactionsHistory isOpen={isInvoiceTransactionModalOpen} onRequestClose={handleCloseInvoiceTransactionModal} invoiceId={selectedInvoiceId}/>
                  )}
                </div>
              </div>
            </div>
          </div>
          {loader && <div className="loading"></div>}
        </div>
 
    );
  }

export default ViewOutgoingInvoicesByLabCorporate;
